import styled from "styled-components";
import { Link } from "react-scroll";

export const Title = styled.span`
  font-weight: 900;
  font-size: 1rem;
  cursor: pointer;
`;

export const UnderLine = styled(Link)`
  text-decoration: none;
  color: var(--gray-300);
  cursor: pointer;

  &:hover {
    text-decoration: underline 1.5px var(--gray-300);
    color: var(--gray-300);
  }
`;
